<script context="module" lang="ts">
	import Section from '$lib/components/layout/Section.svelte';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';

	export const config: SectionConfig = {
		collection: 'section_iframe',
		availableFor: ['pages', 'special-pages'],
		query: gql`
			translations {
				languages_code {
					code
				}
				title
				text
				url
			}
			icon {
				...Media
			}
			background_media {
				...Media
			}

    `
	};
	type Props = {
		url: string;
		title: string;
		text: string;
		icon: any;
		background_media: any;
	};
</script>

<script lang="ts">
	import Wysiwyg from '$lib/components/inputs/WYSIWYG.svelte';
	import Media from '$lib/components/media/Media.svelte';
	import Button from '$lib/components/util/Button.svelte';
	import { onMount } from 'svelte';

	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)

	let overlayVisible = true;
	let iframeLoaded = false;
	let iframeElement: HTMLIFrameElement | null = null;

	const loadIframe = () => {
		if (!iframeLoaded && iframeElement) {
			iframeElement.src = data.url;
			iframeLoaded = true;
		}
	};

	const showIframe = () => {
		loadIframe();

		overlayVisible = false;
	};
</script>

<Section gapType="padding" class="section-iframe">
	<div class="background" slot="background">
		<Media {...data.background_media} fit="cover" transform="l" showAudioButton={false} />
	</div>
	<div class="wrapper">
		<iframe src="" bind:this={iframeElement} style:display={overlayVisible ? 'none' : 'block'} />
	</div>
	{#if overlayVisible}
		<div class="container">
			<div class="overlay">
				<div class="top">
					{#if data.title}
						<div class="title">{data.title}</div>
					{/if}

					<div class="button">
						<Button textKey="iframe_button" iconKey="icon-arrow-right" on:click={showIframe} />
					</div>
				</div>
				{#if data.text}
					<div class="bottom">
						<div class="icon">
							<Media {...data.icon} fit="cover" transform="l" />
						</div>
						<div class="text"><Wysiwyg text={data.text} /></div>
					</div>
				{/if}
			</div>
		</div>
	{/if}
</Section>

<style lang="scss">
	:global(.section-iframe .inner-section) {
		max-width: 1200px !important;
		position: relative;
	}
	.background {
		height: 100%;
	}
	.wrapper {
		display: flex;
		justify-content: center;
	}
	iframe {
		width: 100%;
		height: 65ch;
		border-radius: v(border-radius);
		display: none;
		transition: opacity 0.3s ease;

		@media (max-width: 1300px) {
			height: 85ch;
		}
	}
	.container {
		display: flex;
		justify-content: center;
	}
	.overlay {
		background: color(yellow);
		border-radius: v(border-radius);
		width: 100%;
		padding: v(content-gap-4xl);
		transition: opacity 0.3s ease;
		height: 65ch;
		display: flex;
		flex-direction: column;
		justify-content: center;
		// max-width: 1000px;
		@media (max-width: 800px) {
			padding: 0 v(content-padding-lg);
		}
	}
	.title {
		@include font(h2);
		max-width: 500px;
		hyphens: none;
		@media (max-width: 800px) {
			max-width: 100%;
		}
	}
	.top {
		display: flex;
		border-bottom: solid 1px color(black);
		padding-bottom: v(content-gap-lg);
		justify-content: space-between;
		align-items: center;
		gap: v(content-gap);
		@media (max-width: 900px) {
			flex-direction: column;
			gap: v(content-gap);
			align-items: flex-start;
		}
	}
	.text {
		@include font(text-lg);
	}
	.bottom {
		display: flex;
		gap: v(content-gap-xl);
		padding-top: v(content-gap-lg);
		align-items: center;
		justify-content: center;
	}
	.icon {
		width: 80px;
		height: 80px;
	}
	.button {
		:global(button) {
			white-space: nowrap;
		}
		:global(.text) {
			color: color(white);
		}
		:global(svg path) {
			fill: color(white) !important;
			stroke: color(white) !important;
		}
	}
</style>
